module.exports = __webpack_public_path__ + "img/skin-care-goal-slide2.c0e7b804.gif";